import { render, staticRenderFns } from "./NewH5.vue?vue&type=template&id=501bbc99&scoped=true&"
import script from "./NewH5.vue?vue&type=script&lang=js&"
export * from "./NewH5.vue?vue&type=script&lang=js&"
import style0 from "./NewH5.vue?vue&type=style&index=0&id=501bbc99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501bbc99",
  null
  
)

export default component.exports